import React, { useState, createContext, useContext } from 'react';

const DashboardContext = createContext({
  callbacks: [],
  setCallbacks: () => {}
});

const DashboardProvider = ({ children }) => {
  const [callbacks, setCallbacks] = useState([]);
  return <DashboardContext.Provider value={{ callbacks, setCallbacks }}>{children}</DashboardContext.Provider>;
};

const useUpdateChartLayoutCallbacks = () => {
  const { callbacks, setCallbacks } = useContext(DashboardContext);

  if (callbacks === undefined) {
    throw new Error(`useUpdateChartLayoutCallbacks must be used within a Dashboard Provider`);
  }

  const addUpdateChartLayoutCallback = (callback, callbacks) => setCallbacks([...callbacks, callback]);
  const removeUpdateChartLayoutCallback = (callback, callbacks) =>
    setCallbacks(callbacks.filter((comparisonCallback) => comparisonCallback !== callback));

  return { updateChartLayoutCallbacks: callbacks, addUpdateChartLayoutCallback, removeUpdateChartLayoutCallback };
};

export { DashboardProvider, useUpdateChartLayoutCallbacks };
